import React from 'react';

export default class TurnedOffScreen extends React.Component {
  render() {
    return <div className="screen-off fill-screen">
    </div>
  }
}
